<template>
  <div class="englobe-page">
    <div class="left-section">
      <img src="@/assets/img/logo.svg" alt="Follaw logo" />
      <div class="infos title-medium-regular">
        <p>Notre vision</p>
        <p>
          Rendre accessible et de manière transparente toutes les données
          démocratiques à tous, des citoyens aux cabinets en affaires publiques.
        </p>
        <p>
          Notre outil centralise et vous alerte des informations sociétales,
          politiques et institutionnelles, en temps réel.
        </p>
      </div>
    </div>

    <div class="right-section">
      <div v-if="$slots.button" class="to-login-or-register">
        <slot name="button" />
      </div>
      <div v-if="$slots.form">
        <slot name="form" />
      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.englobe-page {
  display: grid;
  grid-template-columns: 2fr 3fr;
  height: 100vh;

  .left-section {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    gap: 32px;
    background: url("@/assets/img/landing-page-background.svg") no-repeat bottom
      left var(--clr-n8);

    img {
      width: min(50%, 337px);
    }

    &.is-login img {
      width: min(50%, 400px);
    }
  }

  .welcome {
    color: #fff;
  }

  .infos {
    display: flex;
    flex-direction: column;
    gap: 18px;
    max-width: min(50%, 354px);
    color: #fff;

    p {
      margin: 0;
      padding: 0;
    }
  }
}

.right-section {
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  padding: 32px;
  background: #fff;

  .to-login-or-register {
    position: absolute;
    top: 32px;
    right: 32px;
    display: flex;
    align-items: center;
    gap: 16px;
  }
}
</style>
